import { Store } from "@ngrx/store";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { Observable, tap } from "rxjs";
import { AuthTokenService } from "../services/auth-token.service";
import { ProfileStateAction } from "../state/profile-state/profile-state.actions";
import { ActivatedRoute, Router } from "@angular/router";
import { isFormRecord } from "@angular/forms";
import { environment } from "../../environments/environment";
import { signInAgain } from "./sign-in-again";
import { issuedByAnotherAuthority } from "./token-authority";

export function AuthenticationFactory(
    oidc: OidcSecurityService,
    tokenService: AuthTokenService,
    store: Store,
    router: Router
): () => Observable<any> {


    return () => oidc.checkAuth().pipe(tap((w) => {

        // Signed in at another login server than this build's (the dev environments moved to
        // auth.breecelab.work, 27 Oct 2026): every API refuses that token, so it is forgotten and the
        // user signs in again, as if not signed in at all.
        const fromAnotherServer = w.isAuthenticated && issuedByAnotherAuthority(w.accessToken, environment.authority);

        if (!w.isAuthenticated || fromAnotherServer) {
            console.log("You're not authenticated");
            signInAgain(oidc, fromAnotherServer);
            return;
        }

        // init access token
        tokenService.setToken(w.accessToken)

        // Get logged in user languange
        const userLanguage = tokenService.getUserLanguage();

        // Set user language
        store.dispatch(ProfileStateAction.setLanguage({ language: userLanguage || 'en-GB' }));
        
        const requestedUrl = sessionStorage.getItem('returnUrl');
        if (requestedUrl !== null) {
            sessionStorage.removeItem('returnUrl');
            router.navigateByUrl(requestedUrl);
        }
    }));


}

